export default __webpack_public_path__ + "static/media/p1.6a8c9032.png";